import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { CardComponent } from '../../components/card/card.component';

@Component({
  selector: 'vectronic-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  imports: [CardComponent, MatButton, MatDialogClose, MatIcon, MatCheckboxModule],
})
export class ConfirmationDialogComponent {
  confirmMessage = 'Are you sure?';
  confirmTitle = 'Confirm';
  confirmText = 'Confirm';
  cancelText = 'Cancel';

  toggle = false;

  result: { toggle?: boolean };
  dialogRef = inject(MatDialogRef<ConfirmationDialogComponent>);
  data?: {
    title: string;
    message?: string;
    bodyText?: string;
    useMonospaceFont?: boolean;
    hideCancel?: boolean;
    toggleText?: string;
    toggleDefault?: boolean;
  } = inject(MAT_DIALOG_DATA);

  constructor() {
    if (this.data) {
      this.confirmTitle = this.data.title ?? this.confirmTitle;
      this.confirmMessage = this.data.message ?? this.data.bodyText ?? this.confirmMessage;
      this.toggle = this.data.toggleDefault ?? false;
    }
  }
}
